export const WinnerTableStyle = {
  wrapper: {
    position: 'relative',
    '@media (max-width: 639.98px)': {
      background: 'var(--default-white)',
    },

    '@media (max-width: 1199.98px)': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingBottom: '80px',
    },

    '@media (min-width: 1200px)': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
  },

  wrapperTable: {
    background: 'var(--default-white)',
    boxShadow: 'var(--box-shadow--1)',
    paddingTop: '12px',
    borderRadius: '8px',

    '@media (max-width: 1199.98px)': {
      flex: '1',
      height: '100%',
    },
    '@media (min-width: 1200px)': {
      flex: '1',
      height: '100%',
    },
  },

  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 'calc(100% - 74px)',

    '@media (max-width: 639.98px)': {
      boxShadow: 'none',
    },
  },

  container: {
    padding: '0 16px',
  },

  table: {
    maxWidth: '1087px',
    tableLayout: 'fixed',
  },

  tableHeader: {
    borderRadius: '8px !important',

    '& > :nth-of-type(1)': {
      width: '9%',
      textTransform: 'capitalize',
    },

    '& > :nth-of-type(2)': {
      width: '49%',
      textTransform: 'capitalize',

      '@media (min-width: 768px)': {
        width: '20%',
      },
    },

    '& > :nth-of-type(3)': {
      width: '11%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(4)': {
      width: '11%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(5)': {
      width: '24%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(6)': {
      width: '10%',

      '@media (max-width: 767.98px)': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
      },

      '& .MuiTableSortLabel-icon': {
        '@media (max-width: 767.98px)': {
          display: 'none',
        },
      },
    },
    '& > :nth-of-type(7)': {
      width: '5%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
  },

  tableBody: {
    '& td': {
      paddingY: '12px !important',
    },

    '& > :nth-of-type(1)': {
      width: '9%',
    },
    '& > :nth-of-type(2)': {
      width: '49%',
      textTransform: 'capitalize',

      '@media (min-width: 768px)': {
        width: '20%',
      },
    },

    '& > :nth-of-type(3)': {
      width: '11%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(4)': {
      width: '11%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(5)': {
      width: '24%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(6)': {
      width: '10%',
    },
    '& > :nth-of-type(7)': {
      width: '5%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
  },

  buttonWrapper: {
    display: 'flex',
    gap: '16px',
    padding: '20px',
  },

  drawer: {
    '@media (min-width: 1200px)': {
      display: 'none',
    },
  },

  bodyCell: {
    display: 'flex',
    gap: '12px',
  },

  bodyCellImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--neutral-100)',
    width: '48px',
    height: '48px',
    flexShrink: 0,
    borderRadius: '4px',

    svg: {
      height: '24px',
      width: '24px',

      path: {
        fill: 'var(--neutral-300)',
      },
    },

    marginLeft: '-8px',
    '& img': {
      width: '48px !important',
      height: '48px !important',
      borderRadius: '4px',
    },
  },

  bodyCellImageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  bodyCellImageContentName: {
    fontWeight: '700 !important',
  },

  bodyCellImageContentCategory: {
    color: 'var(--neutral-300) !important',
  },

  modal: {
    '@media (max-width: 1199.98px)': {
      display: 'none',
    },

    '.MuiPaper-root': {
      width: '100%',
      maxWidth: '820px',
      padding: '48px 24px 48px',
    },

    '.MuiDialog-container': {},
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    // marginBottom: '12px',

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },
};
